import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export const axiosWrapper = <T = any>(
  endpoint: string,
  method: 'get' | 'post' | 'patch' | 'put' | 'delete',
  data: any = undefined,
): Promise<AxiosResponse<T>> => {
  const token = document.getElementById('csrf_token');
  const options: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'X-CSRFToken': JSON.parse(token.innerHTML) }),
    },
  };

  // just to make sure it's correct
  // @ts-expect-error THIS IS OK
  method = method.toLowerCase();

  switch (method) {
    case 'get':
      return axios.get(endpoint, options);
    case 'delete':
      return axios.delete(endpoint, options);
    default:
      return axios[method](endpoint, data, options);
  }
};

// @ts-ignore
window.axios = axiosWrapper;
